module.exports = __webpack_public_path__ + "img/CR05EU.157794d6.png";